// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  min-height: var(--header-height);
}


/* NAVIGATION */

.nav {
  flex-grow: 1;
  display: flex;
  padding: 20px 30px;
  align-items: center;
  justify-content: space-between;
}

.nav > nav {
  gap: 15px;
  display: flex;
}

.nav > nav > a {
  display: flex;
  align-items: center;
  
  gap: 8px;
  padding: 6px 12px;

  color: inherit;
  font-weight: 600;
  transition: 0.25s;
  text-decoration: none;
}

.nav > nav > a.selected, .nav .dropdown.selected {
  background-color: var(--button-bg);
  color: rgb(var(--accent-color));
  border-radius: var(--radius-small);
}
.nav a:hover, .nav .dropdown li:hover * {
  color: rgb(var(--accent-color));
}


/* ACCOUNT DROPDOWN */

.dropdown {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
}

/* Trigger area */
.dropdown__content {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;
  
  cursor: pointer;
  padding: 6px 12px;
  transition: 0.25s;
  -webkit-user-select: none;
          user-select: none;
  border-radius: var(--radius-small);
  background-color: var(--button-bg);
}

.dropdown__content > span {
  transition: 0.25s;
}
.dropdown__content > .dropdown__title {
  font-weight: 600;
  padding: 0 4px 0 8px;
}

.dropdown__content:hover > span, .dropdown__list.open ~ .dropdown__content {
  color: rgb(var(--accent-color));
}
.dropdown > #admin:not(.open) ~ .dropdown__content {
  background-color: transparent;
}

/* Dropdown */
.dropdown__list {
  top: 100%;
  margin: 0;
  padding: 0;
  min-width: 100%;
  z-index: var(--z-index-dropdown);

  overflow: hidden;
  list-style: none;
  position: absolute;
  visibility: hidden;
  white-space: nowrap;

  opacity: 0;
  cursor: default;
  transition: 0.25s;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0px 0px 10px 2px var(--button-bg-darker);
}

/* Dropdown options list */
.dropdown__list > li {
  outline: 0;
  border: none;
  cursor: pointer;
  transition: background-color 0.25s;

  margin: 4px;
  font-weight: 600;
  border-radius: 3px;
}

.dropdown__list > li > * {
  color: black;
  text-decoration: none;
  transition: color 0.25s;
  
  width: 100%;
  height: 100%;
  padding: 8px 12px;
  display: inline-block;
}

.dropdown__list > li:hover {
  color: rgb(var(--accent-color));
  background-color: var(--button-bg);
}

/* Opening animation */
.dropdown__list.open {
  opacity: 1;
  visibility: inherit;
  transform: translateY(6px);
}
.dropdown__list.open ~ .dropdown__content > .dropdown__arrow {
  transform: rotateZ(180deg);
}


/* RESPONSIVE */

@media(max-width: 1024px) {
  .header nav > *:not([class*="selected"]) span:not([class*="material-icons"]) {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;AAClC;;;AAGA,eAAe;;AAEf;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,QAAQ;EACR,iBAAiB;;EAEjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;AACjC;;;AAGA,qBAAqB;;AAErB;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;;EAE9B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;EACjB,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;AACA;EACE,6BAA6B;AAC/B;;AAEA,aAAa;AACb;EACE,SAAS;EACT,SAAS;EACT,UAAU;EACV,eAAe;EACf,gCAAgC;;EAEhC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kCAAkC;;EAElC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;;AAGA,eAAe;;AAEf;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".header {\r\n  display: flex;\r\n  min-height: var(--header-height);\r\n}\r\n\r\n\r\n/* NAVIGATION */\r\n\r\n.nav {\r\n  flex-grow: 1;\r\n  display: flex;\r\n  padding: 20px 30px;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.nav > nav {\r\n  gap: 15px;\r\n  display: flex;\r\n}\r\n\r\n.nav > nav > a {\r\n  display: flex;\r\n  align-items: center;\r\n  \r\n  gap: 8px;\r\n  padding: 6px 12px;\r\n\r\n  color: inherit;\r\n  font-weight: 600;\r\n  transition: 0.25s;\r\n  text-decoration: none;\r\n}\r\n\r\n.nav > nav > a.selected, .nav .dropdown.selected {\r\n  background-color: var(--button-bg);\r\n  color: rgb(var(--accent-color));\r\n  border-radius: var(--radius-small);\r\n}\r\n.nav a:hover, .nav .dropdown li:hover * {\r\n  color: rgb(var(--accent-color));\r\n}\r\n\r\n\r\n/* ACCOUNT DROPDOWN */\r\n\r\n.dropdown {\r\n  display: flex;\r\n  position: relative;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n/* Trigger area */\r\n.dropdown__content {\r\n  display: flex;\r\n  position: relative;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  \r\n  cursor: pointer;\r\n  padding: 6px 12px;\r\n  transition: 0.25s;\r\n  user-select: none;\r\n  border-radius: var(--radius-small);\r\n  background-color: var(--button-bg);\r\n}\r\n\r\n.dropdown__content > span {\r\n  transition: 0.25s;\r\n}\r\n.dropdown__content > .dropdown__title {\r\n  font-weight: 600;\r\n  padding: 0 4px 0 8px;\r\n}\r\n\r\n.dropdown__content:hover > span, .dropdown__list.open ~ .dropdown__content {\r\n  color: rgb(var(--accent-color));\r\n}\r\n.dropdown > #admin:not(.open) ~ .dropdown__content {\r\n  background-color: transparent;\r\n}\r\n\r\n/* Dropdown */\r\n.dropdown__list {\r\n  top: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  min-width: 100%;\r\n  z-index: var(--z-index-dropdown);\r\n\r\n  overflow: hidden;\r\n  list-style: none;\r\n  position: absolute;\r\n  visibility: hidden;\r\n  white-space: nowrap;\r\n\r\n  opacity: 0;\r\n  cursor: default;\r\n  transition: 0.25s;\r\n  border-radius: 6px;\r\n  background-color: #fff;\r\n  box-shadow: 0px 0px 10px 2px var(--button-bg-darker);\r\n}\r\n\r\n/* Dropdown options list */\r\n.dropdown__list > li {\r\n  outline: 0;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.25s;\r\n\r\n  margin: 4px;\r\n  font-weight: 600;\r\n  border-radius: 3px;\r\n}\r\n\r\n.dropdown__list > li > * {\r\n  color: black;\r\n  text-decoration: none;\r\n  transition: color 0.25s;\r\n  \r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 8px 12px;\r\n  display: inline-block;\r\n}\r\n\r\n.dropdown__list > li:hover {\r\n  color: rgb(var(--accent-color));\r\n  background-color: var(--button-bg);\r\n}\r\n\r\n/* Opening animation */\r\n.dropdown__list.open {\r\n  opacity: 1;\r\n  visibility: inherit;\r\n  transform: translateY(6px);\r\n}\r\n.dropdown__list.open ~ .dropdown__content > .dropdown__arrow {\r\n  transform: rotateZ(180deg);\r\n}\r\n\r\n\r\n/* RESPONSIVE */\r\n\r\n@media(max-width: 1024px) {\r\n  .header nav > *:not([class*=\"selected\"]) span:not([class*=\"material-icons\"]) {\r\n    display: none !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
